// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".verse-check-modal-title {\n  text-align: center;\n  color: var(--reverse-color);\n  display: flex;\n  position: relative;\n  width: 100%;\n  justify-content: center;\n}", ""]);
// Exports
module.exports = exports;
